<mat-card style="border-color: #5775a8;">
  <mat-card-header class="">
    <div class="flex flex-row rounded-lg w-full" style="background-color:#5775a8; padding: 20px;">
      <mat-icon style="color: white;">settings</mat-icon>
      <span style="font-size: large; color: white;">
        Business Administration
      </span>
    </div>
  </mat-card-header>

  <mat-card-content>
    <div class="flex flex-col">
      <br />
      <form [formGroup]="form">
        <div class="flex flex-row rounded-lg w-full">
          <div>
            <mat-form-field>
              <mat-label>Search Text</mat-label>
              <input matInput formControlName="searchText" placeholder="Enter search text here">
            </mat-form-field>
          </div>
          <div>
            <button mat-raised-button (click)="getSearchBusinessData()" class="m-8" style="background: #7ABDF3;">
              <mat-icon>search</mat-icon>
              Search
            </button>
          </div>
          <div class="flex flex-row rounded-lg w-full justify-end">
            <button mat-raised-button (click)="newBusiness()" class="m-8">
              <mat-icon>add</mat-icon>
              Create New Business
            </button>
          </div>
        </div>
      </form>
    </div>

    <div class="flex flex-col w-full">

      <div class="flex flex-col w-full" style="overflow-x:auto;">
        <div class="flex flex-row w-full">
          <div class="flex w-3/4">
            Results: ({{listCount}})
          </div>
          <div class="flex flex-row w-1/2 rounded-lg justify-end">
            <input (keyup)="filterTable($event)" placeholder="Search" [value]="filter" />
          </div>
        </div>
        <div class="flex flex-row w-full">

          <!-- <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #MatSort="matSort" class="w-full"> -->
          <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort fxFlex="100" #TableSort="matSort"
            class="mat-elevation-z8">
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Business Id</th>
              <td mat-cell *matCellDef="let business">{{business.id}}
              </td>
            </ng-container>
            <ng-container matColumnDef="businessName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
              <td mat-cell *matCellDef="let business"><a (click)="rowClick(business)">{{business.businessName}}</a>
              </td>
            </ng-container>
            <ng-container matColumnDef="active">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
              <td mat-cell *matCellDef="let business">
                <span *ngIf="business.active" style="color: green;">Active</span>
                <span *ngIf="!business.active" style="color: red;">Inactive</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="exempt">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Exempt</th>
              <td mat-cell *matCellDef="let business">
                <span *ngIf="business.exempt" style="color: green;">Yes</span>
                <span *ngIf="!business.exempt" style="color: red;">No</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="businessAddress1">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
              <td mat-cell *matCellDef="let business">
                {{business.businessAddress1}}
              </td>
            </ng-container>
            <ng-container matColumnDef="businessCity">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>City</th>
              <td mat-cell *matCellDef="let business">{{business.businessCity}}</td>
            </ng-container>
            <ng-container matColumnDef="businessZip">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Zip</th>
              <td mat-cell *matCellDef="let business">{{business.businessZip}}</td>
            </ng-container>
            <ng-container matColumnDef="totalComplaints">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Complaints</th>
              <td mat-cell *matCellDef="let business" style="text-align: center;">{{business.totalComplaints}}</td>
            </ng-container>
            <ng-container matColumnDef="merge">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Merge</th>
              <td mat-cell *matCellDef="let business">
                <a (click)="mergeBusiness(business)"
                  style="display: flex; align-items: center; justify-content: center;">
                  <mat-icon style="color: green; margin-right: 5px;">merge</mat-icon>
                  Merge
                </a>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="expansion-element-row"></tr>

          </table>
        </div>
        <mat-paginator [pageSizeOptions]="[25, 100]" #TablePaginator="matPaginator"
          showFirstLastButtons></mat-paginator>
      </div>

    </div>

  </mat-card-content>
</mat-card>